import { ChangeEvent, FC, ReactNode, createContext, useCallback, useRef, useState, useMemo } from "react";

type ContextType = {
  files: File[];
  clearImage: (index?: number) => void;
  enableMultiple: () => void;
};

export const AttachFileContext = createContext({} as ContextType);

interface Props {
  children: ReactNode;
}

const Context: FC<Props> = ({ children }) => {
  const _imageUploadRef = useRef(null);

  const [isMultiple, setIsMultiple] = useState(false);
  const [files, setFiles] = useState<File[]>([]);

  const onChangeFile = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const files = [];

    for (let i = 0; i < e.target.files.length; i++) {
      files.push(e.target.files[i]);
    }

    setFiles(files);
  }, []);

  const clearImage = useCallback(
    (index?: number) => {
      const list = [...files];

      if (index !== undefined) {
        list.splice(index, 1);
        setFiles(list);
      } else {
        setFiles([]);
      }

      if (_imageUploadRef.current) {
        _imageUploadRef.current.value = null;
      }
    },
    [files]
  );

  const enableMultiple = useCallback(() => {
    setIsMultiple(true);
  }, []);

  const value = useMemo(() => {
    return {
      files,
      clearImage,
      enableMultiple,
    };
  }, [files, clearImage, enableMultiple]);

  return (
    <AttachFileContext.Provider value={value}>
      {children}
      <input
        id="upload"
        type="file"
        multiple={isMultiple}
        style={{ display: "none" }}
        ref={_imageUploadRef}
        disabled={!!files.length}
        onChange={onChangeFile}
      />
    </AttachFileContext.Provider>
  );
};

export default Context;
